import React from 'react';
import { Pagination } from 'semantic-ui-react';

/**
 * Reusable pagination footer component
 * Displays pagination controls and item count information
 */
const PaginationFooter = ({
    activePage,
    totalPages,
    totalItems,
    filteredItems,
    hasActiveFilters,
    onPageChange,
    pageStart,
    pageEnd
}) => {
    const displayText = (() => {
        const total = filteredItems.length;
        const start = total === 0 ? 0 : pageStart + 1;
        const end = Math.min(pageEnd, total);
        const baseText = `Showing ${start}-${end} of ${total}`;
        return hasActiveFilters && totalItems !== total
            ? `${baseText} (filtered from ${totalItems} total)`
            : baseText;
    })();

    return (
        <div style={{
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: 'white',
            padding: '8px 10px',
            borderTop: '1px solid rgba(0,0,0,0.08)',
            zIndex: 100,
            boxShadow: '0 -2px 4px rgba(0,0,0,0.05)'
        }}>
            <div style={{ color: '#666', fontSize: '0.9em' }}>
                {displayText}
            </div>
            <Pagination
                activePage={activePage}
                totalPages={totalPages}
                onPageChange={(e, data) => onPageChange(Number(data.activePage))}
                size="small"
                siblingRange={1}
                boundaryRange={0}
                ellipsisItem={null}
                firstItem={null}
                lastItem={null}
                prevItem={{ content: 'Prev', icon: 'angle left' }}
                nextItem={{ content: 'Next', icon: 'angle right' }}
            />
        </div>
    );
};

export default PaginationFooter;

